import React from "react";
import {Col, Row} from "reactstrap";
import FormInput from "../../../components/common/form/FormInput";
import FormReactSelect from "../../../components/common/form/FormReactSelect";
import {reviewType} from "../../../util/reviewType";

class ChangeSurveyTypeForm extends React.Component {
    showField() {
        return this.props.isEdit === true ? "hidden" : "";
    }

    render() {
        return (
            <>
                <Row>
                    <Col md="4" sm="6">
                        <FormReactSelect
                            isDisabled={this.props.isDisabled}
                            selectKey={this.props.selectReviewTypeKey}
                            isMulti={false}
                            className="form-control-label"
                            isSearchable={true}
                            label="Survey Type"
                            name={"reviewType"}
                            onChange={this.props.onReviewTypeChange}
                            optionValue={"key"}
                            defaultValue={this.props?.selectedReviewType}
                            optionList={reviewType}
                            optionLabel={"value"}
                            placeHolder="Select a Review Type"
                            errorMsg={this.props.errorObj.companyTypeList || ""}
                            required
                        />
                    </Col>
                    <Col md="4" sm="6">
                        <FormReactSelect
                            selectKey={this.props.selectReviewsSearchEnabledKey}
                            isMulti={false}
                            className="form-control-label"
                            isSearchable={true}
                            label="Review Visible on Global Search"
                            name={"reviewType"}
                            onChange={this.props.onReviewSearchEnabledChange}
                            optionValue={"key"}
                            defaultValue={this.props?.selectedReviewsSearchEnabled}
                            optionList={[{key:true,value:"YES"},{key:false, value:"NO"}]}
                            optionLabel={"value"}
                            placeHolder="Enable Review Search"
                            errorMsg={this.props.errorObj.reviewsSearchEnabled || ""}
                            required
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default ChangeSurveyTypeForm;
